import { motion } from "framer-motion";
import { FileText } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export default function TermsConditions() {
  const { t } = useLanguage();
  const { terms } = t;

  return (
    <div className="cyber-bg min-h-screen" style={{ backgroundColor: "#050814" }}>
      <Navbar />

      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="pt-32 pb-12">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <div className="w-12 h-12 rounded-xl bg-[#00F0FF]/10 border border-[#00F0FF]/20 flex items-center justify-center mb-6">
              <FileText size={22} className="text-[#00F0FF]" />
            </div>
            <h1 className="text-4xl sm:text-5xl font-black text-white" style={{ fontFamily: "Outfit, sans-serif" }}>
              {terms.title}
            </h1>
            <p className="text-slate-500 text-sm mt-3 terminal">{terms.lastUpdated}</p>
          </motion.div>
        </div>

        {/* Sections */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="pb-24 space-y-10"
        >
          {terms.sections.map((section, i) => (
            <div key={i} data-testid={`terms-section-${i}`}>
              <h2 className="text-xl font-bold text-white mb-3" style={{ fontFamily: "Outfit, sans-serif" }}>
                {section.title}
              </h2>
              <div className="cyber-divider mb-4" />
              <p className="text-slate-400 leading-relaxed">{section.content}</p>
            </div>
          ))}
        </motion.div>
      </div>

      <Footer />
    </div>
  );
}
